export const getTotalPages = (count, limit) => Math.ceil(count / limit) || 1;
